import { NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithoutAuthorization } from "../ApiMethod/ApiMethod";

export const GetBannerWebSiteList = async (AppLangID) => {
    const url = `${NewUpdatedBaseUrl}/Banner/GetBannerWebSiteList?AppLangID=${AppLangID}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};